import axios from "axios";
import React, { Component } from "react";
import Loader from "../Loader";
import CvTous from "./cv/CvTous";
import Cvpublique from "./cv/Cvpublique";
import CvBrouillon from "./cv/CvBrouillon";
import { Tab, Tabs } from 'react-bootstrap';

class AllCv extends Component {
  state = {
    loading: true,
    error: null,
    totalCvs: 0,
    totalCvsPublished: 0,
    totalCvsDraft: 0,
    tabKey: 'one',
  };

  componentDidMount() {
    this.loadCvCount();
  }

  // Méthode pour récupérer le comptage des CV
  loadCvCount = async () => {
    try {
      const [responseAll, responsePublished, responseDraft] = await Promise.all([
        axios.get('/cvs_count'),
        axios.get('/cvs_count?status=true'),
        axios.get('/cvs_count?status=false'),
      ]);

      this.setState({
        totalCvs: responseAll.data.count,
        totalCvsPublished: responsePublished.data.count,
        totalCvsDraft: responseDraft.data.count,
        loading: false,
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des données:", error);
      this.setState({ error: "Une erreur est survenue lors du chargement des données.", loading: false });
    }
  };

  handleTabs = (key) => {
    this.setState({ tabKey: key });
  };

  render() {
    const { loading, error, totalCvs, totalCvsPublished, totalCvsDraft, tabKey } = this.state;
    const { user } = this.props;

    if (loading) {
      return <Loader />;
    }

    if (error) {
      return (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      );
    }

    return (
      <div className="adminx-content">
        <div className="adminx-main-content">
          <div className="container-fluid">
            <nav aria-label="breadcrumb" role="navigation">
              <ol className="breadcrumb adminx-page-breadcrumb">
                <li className="breadcrumb-item"><a href="/">Tableau de bord</a></li>
                <li className="breadcrumb-item"><a href="#">Candidats</a></li>
                <li className="breadcrumb-item active" aria-current="page">Tous les Candidats</li>
              </ol>
            </nav>

            <div className="pb-3 d-flex justify-content-between">
              <h3>Tous les candidats</h3>
            </div>

            {user.role === 'Administrateur' && (
              <Tabs activeKey={tabKey} onSelect={this.handleTabs}>
                <Tab eventKey="one" title={`Tous les CV (${totalCvs})`}>
                  <br />
                  <div className="table-responsive-md">
                    <CvTous utilisateur={user} />
                  </div>
                </Tab>
                <Tab eventKey="two" title={`CV Publiés (${totalCvsPublished})`}>
                  <br />
                  <div className="table-responsive-md">
                    <Cvpublique utilisateur={user} />
                  </div>
                </Tab>
                <Tab eventKey="three" title={`CV en Brouillon (${totalCvsDraft})`}>
                  <br />
                  <div className="table-responsive-md">
                    <CvBrouillon utilisateur={user} />
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AllCv;
